import { useMutation } from '@tanstack/react-query'
import { togglePushNotificationAlertStatus } from '@core/Utils/notifications/pushNotificationAlerts'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { queryClient } from '@core/Data/ReactQuery/queryClient'

export const useBlackbookPushAlertMutation = ({
  accountNumber,
}: {
  accountNumber: number | null
}) =>
  useMutation({
    mutationFn: async (enable: boolean) => {
      return togglePushNotificationAlertStatus({
        alertType: 'blackbook',
        accountNumber,
        isEnabled: enable,
      })
    },
    onMutate: async enable => {
      queryClient.cancelQueries({ queryKey: [queryKeys.blackbookPushAlerts] })

      const previous = queryClient.getQueryData([queryKeys.blackbookPushAlerts])

      queryClient.setQueryData([queryKeys.blackbookPushAlerts], enable)

      return { previous, enable }
    },
    onError: (error, variables, context) => {
      if (context?.previous) {
        queryClient.setQueryData([queryKeys.blackbookPushAlerts], context.previous)
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.blackbookPushAlerts] })
    },
  })
